import { ApiTags, rootApi } from "../../../../services/rootApi";

const TAG = ApiTags.AcademicRegistration;
export interface IABCForm {
  id: string
  aadharName: string,
  aadharNumber: string,
  dob: string,
  gender: string,
  mobile: string,
}

export interface ABCResponse {
  abC_ACCOUNT_ID: string; 
  message: string;  
  status_code: number;
  status: string;      
}

const abcIdApi = rootApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    createAbcId: builder.mutation<ABCResponse, Partial<IABCForm>>({
      query: (payment) => ({
        url: "/AbcID",
        method: "POST",
        body: payment
      }),
      invalidatesTags: (result) => result ? [{ type: TAG, id: result.abC_ACCOUNT_ID }, TAG] : [TAG]
    }),
  }),
});

export const {
  useCreateAbcIdMutation,
} = abcIdApi;
